import { Component as PComponent } from "preact";
import PropTypes from "prop-types";
import Loading from "../Loading";
import ErrorBlock from "../ErrorBlock";
import { sessionServices } from "../../../services/session-services";

/**
 * A public higher-order component to access the imperative API
 */
export const withSession = (Component, showLoader, showError) => {
	class HOC extends PComponent {
		componentDidMount() {
			const {sessionID} = this.props;
			this._mounted = true;

			if(sessionID) {
				this.setState({loading: true});

				this._controller = new AbortController();
				sessionServices.getItem(sessionID, undefined, this._controller.signal).then((session) => {
					this._mounted && this.setState({session});
				}, error => {
					this._mounted && this.setState({error});
				}).finally(() => {
					this._mounted && this.setState({loading: false});
				});
			}
		}

		componentWillUnmount() {
			this._mounted = false;
			this._controller && this._controller.abort();
		}

		render({}, {loading, error, session}) {
			if(showLoader && loading) {
				return <Loading block={true} />;
			}

			if(showError && error) {
				return <ErrorBlock error={error}/>;
			}

			return (
				<Component
					session={session}
					onSession={s => this.setState({session: s})}
					{...this.props}
				/>
			);
		}

		static get displayName() {
			return "withSession(" + (Component.displayName || Component.name) + ")"
		}

		static get wrappedComponent() {
			return Component;
		}

		static get propTypes() {
			return {
				sessionID: PropTypes.number,
			}
		}

		static get stateProps() {
			return {
				loading: PropTypes.bool,
				error: PropTypes.object,
				session: PropTypes.object,
			}
		}
	}

	return HOC;
};

export default withSession;
